var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags"},[_c('app-game-item-field-name-status',{attrs:{"format":_vm.format,"item":_vm.item,"filter":_vm.filter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }